import { Component, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';

import {FleetChecklist} from 'src/app/validation/models/fleet-checklist';
import {FleetChecklistBulkEditorService} from '../../services/fleet-checklist-bulk-editor.service';

@Component({
  selector: 'app-upload-programacion-view',
  templateUrl: './upload-programacion-view.component.html',
  styleUrls: ['./upload-programacion-view.component.scss','../../styles/styles-component.scss']
})
export class UploadProgramacionViewComponent {
  @Output() onUploaded = new EventEmitter<FleetChecklist[]>();

  // file
  currentPreviewUrl?: string;
  filePreview: SafeUrl | null = null;
  fileSizeLabel: string = '';

  submitted = false;
  dragging = false;

  constructor(
    private sanitizer: DomSanitizer,
    public bulkEditor: FleetChecklistBulkEditorService,
  ) {}

  get f() {
    return this.bulkEditor.uploadImageform.controls;
  }
  get file(): File | null {
    return this.f.file.value;
  }
  get hasFile(): boolean {
    return !!this.file;
  }

  resetForm(): void {
    this.bulkEditor.resetForm();
  }
  async onSubmit(): Promise<void> {
    this.submitted = true;
    if(this.bulkEditor.isFormValid()){
      const result = await Swal.fire({
        title: '¿Subir programación?',
        html: `
          <div class="text-start">
            <p>Se guardará la programación con los siguientes detalles:</p>
            <p>Nombre: <strong>${this.f.name.value}</strong></p>
            <p>Archivo: <strong>${this.file?.name}</strong> (${this.fileSizeLabel})</p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, subir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3b82f6',
        cancelButtonColor: '#ebebeb',
        reverseButtons: true
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          text: 'Por favor espera mientras se carga la programación.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        try {
          let created = await this.bulkEditor.onUploadImageFormSubmit();

          Swal.close(); // cerrar loading

          if (created == null) {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al cargar la programación.',
              icon: 'error',
              confirmButtonColor: '#3b82f6'
            });
          } else {
            this.onUploaded.emit(created);

            await Swal.fire({
              title: '¡Programación cargada!',
              text: 'La programación y la imagen se han procesado correctamente.',
              icon: 'success',
              confirmButtonColor: '#3b82f6',
              timer: 2000,
              timerProgressBar: true
            });

            this.onCancel();
          }

        } catch (error) {
          Swal.close();

          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error inesperado durante la carga.',
            icon: 'error',
            confirmButtonColor: '#3b82f6'
          });
        }
      }
    }
  }
  onCancel(): void {
    this.submitted = false;
    this.removeFile();
    this.bulkEditor.closeModals();
    this.resetForm();
  }

  processFile(file: File): void {
    if (!file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Formato no permitido',
        text: 'Por favor, suba únicamente imágenes.',
        icon: 'warning',
        confirmButtonColor: '#3b82f6'
      });
      return;
    }
    this.removeFile();
    this.bulkEditor.setFile(file);
    this.buildPreview(file);
  }

  // EVENTS INPUT
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    this.processFile(input.files[0]);
    input.value = '';
  }
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = false;

    if (!event.dataTransfer?.files?.length) return;
    this.processFile(event.dataTransfer.files[0]);
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = true;
  }
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = false;
  }

  /* UTILS */
  buildPreview(file: File) {
    this.fileSizeLabel = this.formatBytes(file.size);

    this.currentPreviewUrl = URL.createObjectURL(file);
    this.filePreview = this.sanitizer.bypassSecurityTrustUrl(this.currentPreviewUrl);
  }
  removeFile(): void {
    if (this.currentPreviewUrl) {
      URL.revokeObjectURL(this.currentPreviewUrl);
      this.currentPreviewUrl = undefined;
    }

    this.filePreview = null;
    this.fileSizeLabel = '';
    this.bulkEditor.removeFile();
  }
  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
